import { useContext } from "react";
import { FormContext, FormContextValue } from "@welldigital/components";

export function useFormContext() {
  return useContext<FormContextValue>(FormContext);
}
